import { c as _c } from "react/compiler-runtime";
import { Flex, FlexColumn, SkeletonBlock, SkeletonLine, TableCell, TableRow } from "@opensea/ui-kit";
import { NOTIFICATION_TABLE_CLASSNAMES } from "./styles";
export function NotificationsTableRowSkeleton() {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <TableCell className={NOTIFICATION_TABLE_CLASSNAMES.unreadBadge} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <SkeletonBlock className="size-8 rounded" />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <TableCell className={NOTIFICATION_TABLE_CLASSNAMES.description}><Flex className="gap-3">{t1}<FlexColumn className="gap-1"><SkeletonLine className="h-3 w-16" /><SkeletonLine className="h-4 w-32" /></FlexColumn></Flex></TableCell>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <TableRow className={NOTIFICATION_TABLE_CLASSNAMES.row}>{t0}{t2}<TableCell className={NOTIFICATION_TABLE_CLASSNAMES.side}><FlexColumn className="gap-1"><SkeletonLine className="h-3 w-16" /><SkeletonLine className="h-4 w-16" /></FlexColumn></TableCell></TableRow>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}